import { FunctionComponent } from 'preact';
import { useSelector } from 'react-redux';
import { BrandLogo } from '../brandLogo/brandLogo';
import { Title } from '../title/title';
import { useStyles } from '../../../../common/hooks/useStyles';
import { getLogoAndTitleStyleObject } from './logoAndTitle.style';
import { adsDataSelector } from '../../../../common/store/selectors/adsData.selector';
import { brandingDataSelector } from '../../../../common/store/selectors/brandingData.selector';
import { playerDataSelector } from '../../../../common/store/selectors/playerData.selector';
import { css } from '../../../../common/styles/styles.utils';
import { Icon } from '../../../../common/components/icon/icon';
import { CONTROLS_ICON_TYPES } from '../../icon/iconMapper';
import { getShareId } from '../../htmlElements/htmlElementsIdGetter';

interface LogoAndTitleComponentVariablesProps {
    ctaButtonWidth: number;
}

export const LogoAndTitle: FunctionComponent<LogoAndTitleComponentVariablesProps> = props => {
  const { ctaButtonWidth } = props;
  const isVastAd = useSelector(adsDataSelector.isVastAd);
  const adBreak = useSelector(adsDataSelector.adBreak);
  const brandingLogoSrc = useSelector(brandingDataSelector.brandingLogoSrc);
  const playerSize = useSelector(playerDataSelector.playerSize);
  const playerUniqueId = useSelector(playerDataSelector.playerInstanceUniqueId);

  const showLogo = brandingLogoSrc !== '';
  const showShareIcon = false;
  // const showShareIcon = !anchorActive && !showAdControls && (playerSize === 'large' || playerSize === 'extraLarge') && playbackMethod !== 'none'; // FOR THE NEXT VERSION

  const showAdControls = isVastAd && adBreak;

  const styles = useStyles(getLogoAndTitleStyleObject, [showLogo, playerSize, ctaButtonWidth]);
  const { titleAndLogoStyle, shareIconStyle } = styles;

  const ShareIcon: FunctionComponent = () => (
    showShareIcon
      ? <Icon icon={CONTROLS_ICON_TYPES.SHARE_FILL} style={shareIconStyle} id={getShareId(playerUniqueId)} /> : null
  );

  return !showAdControls
      && (
      <div style={css(titleAndLogoStyle)}>
        <BrandLogo />
        <Title showShareIcon={showShareIcon} />
        <ShareIcon />
      </div>
      );
};
